import { useStyletron } from "baseui";
import { Block } from "baseui/block";
import { Button, ButtonProps, KIND, SHAPE, SIZE } from "baseui/button";
import { ButtonGroup, MODE } from "baseui/button-group";
import { Check } from "baseui/icon";
import { ListItem, ListItemLabel } from "baseui/list";
import { ModalButton, } from "baseui/modal";
import { ProgressSteps, Step } from "baseui/progress-steps";
import { useSnackbar } from "baseui/snackbar";
import { LabelLarge, LabelMedium, LabelSmall, ParagraphSmall } from "baseui/typography";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IAutomationObject } from "../../../automationObjects";
import { BacnetObjectState, BacnetObjectTypes, BacnetPropertyIds, CreateObjectMappingCommand, CreatePropertyMappingCommand, useCreateMappingMutation, useCreatePropertyMappingMutation } from "../../../services/mapping/bacnet";
import { VscCombine, VscListSelection } from 'react-icons/vsc'
import BacnetPropertyMappingBasicForm from "./BacnetPropertyMappingBasicForm";
import BacnetPropertyMappingCustomMapperForm from "./BacnetPropertyMappingCustomMapperForm";
import { IoIosLink } from "react-icons/io";
import { Banner } from "baseui/banner";
import { ObjectNavigatorModal } from "../../ObjectSelector/Modal";
import { GetObjectUrl } from "../../../utils/navigationService";
import { ModalAutoSize } from "../../../components/ModalAutoSize";
import { useReportMutationState } from '../../../hooks/useReportMutationState';
import { useLocalStorage } from "../../../hooks";


const AddBacnetMappingModal = (props: {
    bacnetObject: BacnetObjectState
    isOpen: boolean,
    setIsOpen: any,
    bacnetDeviceId: number,
    resourceGroupId: string,
}) => {

    const [selectedItem, setSeletctedItem] = useLocalStorage<any>(`${props.resourceGroupId}-${props.bacnetDeviceId}`,undefined);
    
    const navigate = useNavigate();
    const [, theme] = useStyletron();

    const [current, setCurrent] = useState(0);
    const onSelected = (item: IAutomationObject) => { setSeletctedItem(item); }
    const [mappingType, setMappingType] = useState<number>(0);

    // bacnet property mapping
    const pv = b3[BacnetPropertyIds.PRESENT_VALUE];
    const [bacnetProperty, setBacnetProperty] = useState([pv]);
    const onBacnetPropertyChanged = (value: any) => {
        setBacnetProperty(value)
    };
    const [propertyName, setPropertyName] = useState(undefined);
    const onPropertyNameChanged = (value: any) => setPropertyName(value);
    const [converter, setConverter] = useState<any[]>([]);
    const onConverterChanged = (value: any) => setConverter(value);
    const [converterParams, setConverterParams] = useState("");
    const onConverterParamsChanged = (value: any) => setConverterParams(value);

    // api
    const [createMapping, createMappingResult] = useCreateMappingMutation();
    const [createPropertyMapping, createPropertyMappingResult] = useCreatePropertyMappingMutation();

    const handleOnCreateMappingSuccess = () => {
        props.setIsOpen(false);
        setCurrent(0);
    }
    useReportMutationState(createMappingResult, handleOnCreateMappingSuccess, {
        actionMessage: "Goto Object",
        actionOnClick: () => navigate(GetObjectUrl(selectedItem?.resourceGroupId ?? '', selectedItem?.id ?? '')),
        message: 'sucessfully added',
        startEnhancer: ({ size }) => <Check size={size} />,
    });
    useReportMutationState(createPropertyMappingResult, handleOnCreateMappingSuccess, {
        actionMessage: "Goto Object",
        actionOnClick: () => navigate(GetObjectUrl(selectedItem?.resourceGroupId ?? '', selectedItem?.id ?? '')),
        message: 'sucessfully added',
        startEnhancer: ({ size }) => <Check size={size} />,
    });

    function onCreateMappingClick(): void {
        if (mappingType === 0 && selectedItem) { // object mapping 
            const cmd: CreateObjectMappingCommand = {
                deviceId: props.bacnetObject.edgeDeviceId,
                bacnetDeviceId: props.bacnetDeviceId,
                bacnetInstanceId: props.bacnetObject.instanceId,
                bacnetObjectType: props.bacnetObject.objectType,
                moduleId: 'bacnetconnector',
                objectId: selectedItem?.id,
                resourceGroupId: selectedItem?.resourceGroupId
            }
            createMapping(cmd);
        }
        else if (mappingType === 1 && selectedItem) {
            const selProp = bacnetProperty[0] as any;
            const cmd: CreatePropertyMappingCommand = {
                deviceId: props.bacnetObject.edgeDeviceId,
                bacnetDeviceId: props.bacnetDeviceId,
                bacnetInstanceId: props.bacnetObject.instanceId,
                bacnetObjectType: props.bacnetObject.objectType,
                moduleId: 'bacnetconnector',
                objectId: selectedItem?.id,
                bacnetProperty: selProp.id,
                propertyName: propertyName ?? '',
                resourceGroupId: selectedItem?.resourceGroupId
            }
            if (converter.length === 1)
                cmd.mapper = { type: converter[0].fullName, parameters: converterParams !== "" ? JSON.parse(converterParams) : undefined }
            createPropertyMapping(cmd);
        }
    }


    const [showObjectSelector, setShowObjectSelector] = useState(false);
    const handleShowObjectSelector = (value: boolean) =>  setShowObjectSelector(value)



    const buttonConditions = [
        {
            next: { disabled: selectedItem === undefined, onClick: () => setCurrent(1) }
        },
        {
            next: { disabled: mappingType < 0, onClick: () => mappingType === 1 ? setCurrent(2) : setCurrent(4) },
            prev: { onClick: () => setCurrent(0) }
        },
        {
            next: { onClick: () => setCurrent(3), disabled: !propertyName },
            prev: { onClick: () => setCurrent(1) }
        },
        {
            next: { onClick: () => setCurrent(4) },
            prev: { onClick: () => setCurrent(2) }
        },
        {
            prev: { onClick: () => mappingType === 1 ? setCurrent(3) : setCurrent(1) }
        }

    ]
    const nextButtonProps = buttonConditions[current]?.next;
    const prevButtonProps = buttonConditions[current]?.prev;
    const filter = (app: IAutomationObject) => app.resourceGroupId === props.resourceGroupId;

    return (
        <ModalAutoSize
            isOpen={props.isOpen}
            setIsOpen={props.setIsOpen}
            header={<><IoIosLink></IoIosLink> Add mapping</>}
            body={<>
                <ListItem>
                    <ListItemLabel description={props.bacnetObject.objectDescription}>
                        {props.bacnetObject.objectName} - {BacnetObjectTypes[props.bacnetObject.objectType]}[{props.bacnetObject.instanceId}]
                    </ListItemLabel>
                </ListItem>
                <ProgressSteps current={current}>
                    <Step title="Select or Create App">
                        <Block display='flex' flexDirection='column' gridGap={'20px'}>
                            <Block display='flex' flexDirection='row' gridGap={'20px'}>
                                <Button onClick={() => handleShowObjectSelector(true)}>Select Item</Button>
                                {selectedItem &&
                                    <ListItem>
                                        <ListItemLabel description={<ItemDescription item={selectedItem}></ItemDescription>}>
                                            {selectedItem?.description}
                                        </ListItemLabel>
                                    </ListItem>
                                }
                                {selectedItem === undefined &&
                                    <Banner kind="warning">please select an App as mapping target</Banner>
                                }

                            </Block>
                            {showObjectSelector &&
                                <ObjectNavigatorModal title='Select App as mapping target'
                                    filter={filter}
                                    currentSelectedParent={selectedItem}
                                    isOpen={showObjectSelector}
                                    showAddObject
                                    setIsOpen={(e: boolean) => handleShowObjectSelector(e)}
                                    subTitle={<ListItem>
                                        <ListItemLabel description={props.bacnetObject.objectDescription}>
                                            {props.bacnetObject.objectName} - {BacnetObjectTypes[props.bacnetObject.objectType]}[{props.bacnetObject.instanceId}]
                                        </ListItemLabel>
                                    </ListItem>}
                                    onSelected={onSelected}></ObjectNavigatorModal>
                            }
                        </Block>
                    </Step >
                    <Step title="Select Mapping Type">

                        <ButtonGroup
                            mode={MODE.radio}
                            selected={mappingType}
                            onClick={(_event, index) => {
                                setMappingType(index);
                            }}
                            size={SIZE.large}
                            kind="secondary"
                        >
                            <Button startEnhancer={() => <VscCombine></VscCombine>}>
                                Object Mapping
                            </Button>
                            <Button startEnhancer={() => <VscListSelection></VscListSelection>}>Property Mapping</Button>
                        </ButtonGroup>

                    </Step >
                    <Step title="Property Mapping Details" >
                        {selectedItem &&
                            <>
                                <BacnetPropertyMappingBasicForm targetApp={selectedItem} propertyName={propertyName} onPropertyNameChange={onPropertyNameChanged} bacnetProperty={bacnetProperty} onBacnetPropertyChange={onBacnetPropertyChanged}></BacnetPropertyMappingBasicForm>
                            </>
                        }
                    </Step >
                    <Step title="Custom mapper">
                        <BacnetPropertyMappingCustomMapperForm converter={converter} onConverterChange={onConverterChanged} converterParams={converterParams} onConverterParamsChange={onConverterParamsChanged}></BacnetPropertyMappingCustomMapperForm>
                    </Step >
                    <Step isLast title="Summary" >
                        <LabelLarge marginBottom="20px">Object</LabelLarge>
                        <ListItemLabel description={<ItemDescription item={selectedItem}></ItemDescription>}>
                            {selectedItem?.description}
                        </ListItemLabel>
                        <LabelLarge marginBottom="20px" marginTop="20px">Mapping</LabelLarge>
                        <ParagraphSmall>{mappingType === 1 ? "Property Mapping" : "Object Mapping"}</ParagraphSmall>
                        {mappingType === 1 &&
                            (<>
                                <ParagraphSmall><>{bacnetProperty[0].label} -- {propertyName}</></ParagraphSmall>
                            </>)
                        }
                    </Step>
                </ProgressSteps>
            </>}
            footer={<>

                {prevButtonProps && <ModalButton kind="tertiary" {...prevButtonProps}>
                    Back
                </ModalButton>}
                {nextButtonProps && <ModalButton kind="secondary" {...nextButtonProps}>
                    Next
                </ModalButton>}
                {selectedItem &&
                    <ModalButton  onClick={() => onCreateMappingClick()} isLoading={createPropertyMappingResult?.isLoading || createMappingResult?.isLoading} disabled={!selectedItem}>Create Mapping</ModalButton>
                }
            </>}
        ></ModalAutoSize>)


}

export default AddBacnetMappingModal;



function ItemDescription({ item }) {
    const [css] = useStyletron();
    return (
        <>
            {item.name}
            <br></br>
            <span className={css({
                fontSize: '0.8em'
            })}>
                {item.schema}
            </span>
            <br></br>
            <span className={css({
                fontSize: '0.8em'
            })}>
                {item.id}
            </span></>

    )
}

const bacnetPropertys = Object.keys(BacnetPropertyIds).filter((item) => {
    return isNaN(Number(item));
});
const b3 = bacnetPropertys.map((item: any, index: number) => { return { label: item, id: index } });